import { AppointmentData, ClientPack, GeneralSettingsData, PackSettings, Payment, PaymentStatus, SettingsData } from "../../models"
import { parseTimeStringToMinutes } from "../utils"

/** Price + Expenses */
export const getTotalPrice = (a: AppointmentData): number =>
    (a.price ?? 0) + (a.expenses ?? []).reduce((t, e) => t + ((e?.value ?? 0) * (e?.quantity ?? 1)), 0)

/** ActualPriceWithPack + Expenses */
export const getActualTotalPrice = (a: AppointmentData): number =>
    (a.actualPriceWithPack ?? a.price ?? 0) + (a.expenses ?? []).reduce((t, e) => t + ((e?.value ?? 0) * (e?.quantity ?? 1)), 0)

/** Sum of payments + Price if pack is used */
export const getAppointmentTotalPayments = (a: AppointmentData): number =>
    (a.packId ? a.price : 0) + (a.payments ?? []).reduce((t, p) => t + (p.status && [PaymentStatus.Manual, PaymentStatus.Success].includes(p.status) ? p.value : 0), 0)

/** Sum of payments + Price if pack is used */
export const getTotalPayments = (p?: Payment[]): number =>
    (p ?? []).reduce((t, p) => t + (p.status && [PaymentStatus.Manual, PaymentStatus.Success].includes(p.status) ? p.value : 0), 0)

/** Sum of payments + Price if pack is used */
export const getActualTotalPayments = (a: AppointmentData): number =>
    (a.packId ? (a.actualPriceWithPack ?? a.price) : 0) + (a.payments ?? []).reduce((t, p) => t + (p.status && [PaymentStatus.Manual, PaymentStatus.Success].includes(p.status) ? p.value : 0), 0)

export const getActualPriceWithPack = (a: AppointmentData, p: ClientPack, t: PackSettings): number => {
    if(!a.packId) {
        return 0
    } if(!!t.totalCredits) {
        if(!t.appointmentTypesCredits || !t.appointmentTypesCredits[a.type]) return NaN
        return t.appointmentTypesCredits[a.type] * p.price / t.totalCredits
    } else if(!!t.totalMinutes) {
        const duration = Math.abs(parseTimeStringToMinutes(a.end)-parseTimeStringToMinutes(a.start))
        return duration * p.price / t.totalMinutes
    }
    return NaN
}

export const serviceName = (serviceId: string, settings: GeneralSettingsData) => settings?.services?.[serviceId]?.name || serviceId
export const serviceId = (serviceName: string, settings: GeneralSettingsData) => Object.entries(settings.services).find(([_, s]) => s.name === serviceName)?.[0] ?? serviceName